import React, { createElement, useEffect, useCallback } from 'react';
import { useLocalObservable, observer } from 'mobx-react';
import { apiStore } from '@/store';
import { TYPE } from '@/components/form/form/components/form-api-select';
import { Select } from '@alifd/next';
import request from '@/utils/request';
import { ApiMap, idList } from '@/components/form/form/components/form-api-select/accounting-event-list';
const ApiSelectFilter = observer(({ onChange, name, fieldName, type }) => {
    const { setApiDataSource } = useLocalObservable(() => apiStore);
    const [dataSource, setDataSource] = React.useState([]);
    const fetchData = useCallback(async () => {
        const isIdList = idList.includes(type);
        const apiName = ApiMap[type];
        const setDatas = (content) => {
            const data = content?.map(({ name: label, code, id }) => {
                return {
                    label: `${label}(${code})`,
                    value: isIdList ? id : code,
                };
            });
            setDataSource(data);
            setApiDataSource(type, data);
        };
        if (type === 'DECISION_MAP_LIST') {
            const { content = [] } = await request.get(apiName, {
                params: { usageScenario: '902900000003' },
            });
            setDatas(content);
        }
        else if (type === 'ACCT_PARAM_ID_ITEM_LIST' || type === 'ACCT_PARAM_ID_ABSTRACT_LIST') {
            const paramCatType = type === 'ACCT_PARAM_ID_ITEM_LIST' ? 'item' : 'abstract';
            const { content = [] } = await request.get(apiName, {
                params: { paramCatType },
            });
            setDatas(content);
        }
        else {
            const { content = [] } = await request.get(apiName);
            setDatas(content);
        }
    }, [setApiDataSource, type]);
    useEffect(() => {
        fetchData();
    }, [fetchData]);
    const __onChange = (value) => {
        const filterValue = Array.isArray(value) ? value : [value];
        const joinStr = filterValue.join(',');
        onChange({
            operator: 'in',
            dataType: 'stringArray',
            value: joinStr,
            name,
            fieldName,
        });
    };
    switch (type) {
        case TYPE.ENTITY_TREE:
            return createElement("div", null, "ENTITY_TREE");
        default:
            break;
    }
    return (createElement(Select, { style: { width: '100%' }, mode: "multiple", showSearch: true, hasClear: true, dataSource: dataSource, onChange: __onChange }));
});
export default ApiSelectFilter;
